import * as React from "react";

import { Step } from "../TourTypes";

export const showTourButtonTourStep: Step = {
    id: "candyform_showtourbutton",
    controlId: "show-tour-button",
    header: "Подсказки рядом",
    group: ["panel", "menu"],
    content: (
        <div>
            {"Если возникнут вопросы, пройдите тур"}
            <br />
            {"по основным возможностям формы"}
        </div>
    ),
    positions: ["right middle", "right bottom"],
    order: 50,
    isEnabled: true,
};
